/**
 * Controller: reportsCreateShowGroupsModal
 */
angular.module('acme.view.application.reports.create.showGroupsModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers'
])
.controller('ReportsCreateShowGroupsModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'HelpersService', 'CurrentUserGroups', function($scope, $uibModalInstance, ApiService, HelpersService, CurrentUserGroups) {

  $scope.errors = [];

  $scope.model = [];

  $scope.query = '';

  $scope.init = function() {

    ApiService.groups.list(HelpersService.getPaginator()).then(function(response) {
      var i, ii,
        userGroups = response.data.payload.list;

      for (i=0,ii=userGroups.length;i<ii;i++) {
        if (CurrentUserGroups.indexOf(userGroups[i].name) > -1) {
          userGroups[i].selected = true;
        }
      }

      $scope.model = userGroups;

    }, function(response) {
      var error = response.data.error;
      $scope.errors = [{message: error}];
    });

  };

  $scope.checkQuery = function(userGroup, query) {
    var q = '';
    if (userGroup.name) {
      q += userGroup.name;
    }

    q = q.toLowerCase();

    console.log('ReportsCreateShowGroupsModalController::search', query);
    return (q.indexOf(query) === -1);
  };

  $scope.checkUserGroupsSelected = function() {
    return $scope.getSelected().length;
  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.getSelected = function() {
    var i, ii,
      userGroups = [];

    for (i=0,ii=$scope.model.length;i<ii;i++) {
      if ($scope.model[i].selected && $scope.model[i].name) {
        userGroups.push($scope.model[i].name);
      }
    }

    return userGroups;
  };

  $scope.done = function() {
    $scope.errors = [];
    $scope.success();
  };

  $scope.cancel = function () {
    $scope.errors = [];
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close($scope.getSelected());
  };

  $scope.init();

}]);